import { LIGHT_CONDITION } from './constantes';

export const BLACK_COLOR = 'black-color';
export const BLACK_ALPHA_6_COLOR = 'black-alpha-6-color';
export const BLACK_ALPHA_8_COLOR = 'black-alpha-8-color';
export const LIGHT_30_BLACK_COLOR = 'light-30-black-color';
export const LIGHT_50_BLACK_COLOR = 'light-50-black-color';
export const LIGHT_50_BLACK_ALPHA_8_COLOR = 'light-50-black-alpha-8-color';
export const LIGHT_60_BLACK_COLOR = 'light-60-black-color';
export const BLUE_COLOR = 'blue-color';
export const LIGHT_50_BLUE_COLOR = 'light-50-blue-color';
export const DARK_5_BLUE_COLOR = 'dark-5-blue-color';
export const GREEN_COLOR = 'green-color';
export const ORANGE_COLOR = 'orange-color';
export const RED_COLOR = 'red-color';
export const WHITE_COLOR = 'white-color';
export const OFFLINE_COLOR = 'offline';
export const BRIGHTNESS_IMAGES = 'brightness-images';

export const S52_COLOR_APLRT = 's52.APLRT';
export const S52_COLOR_PSTRK = 's52.PSTRK';
export const S52_COLOR_SHIPS = 's52.SHIPS';
export const S52_COLOR_SYTRK = 's52.SYTRK';
export const S52_COLOR_CHRED = 's52.CHRED';
export const S52_COLOR_RESBL = 's52.RESBL';

// Day color
const DAY_COLOR = {
  [BLACK_COLOR]: '#373736',
  [BLACK_ALPHA_6_COLOR]: 'rgba(55, 55, 54, .6)',
  [BLACK_ALPHA_8_COLOR]: 'rgba(55, 55, 54, .8)',
  [LIGHT_30_BLACK_COLOR]: '#838380',
  [LIGHT_50_BLACK_COLOR]: '#B5B5B4',
  [LIGHT_50_BLACK_ALPHA_8_COLOR]: 'rgba(181, 181, 180, .8)',
  [LIGHT_60_BLACK_COLOR]: '#CFCFCE',
  [BLUE_COLOR]: '#00a5d3',
  [LIGHT_50_BLUE_COLOR]: '#D1F5FF',
  [DARK_5_BLUE_COLOR]: '#008FB7',
  [GREEN_COLOR]: '#afcb38',
  [ORANGE_COLOR]: '#e9883d',
  [RED_COLOR]: '#d22e31',
  [WHITE_COLOR]: 'white',
  [OFFLINE_COLOR]: 'rgba(163, 183, 168, 1)', //-----
  [S52_COLOR_APLRT]: 'rgb(233,136,61)',
  [S52_COLOR_PSTRK]: 'rgb(0,0,0)',
  [S52_COLOR_SHIPS]: 'rgb(0,0,0)',
  [S52_COLOR_SYTRK]: 'rgb(136,152,139)',
  [S52_COLOR_CHRED]: 'rgb(238,90,108)',
  [S52_COLOR_RESBL]: 'rgb(76,135,227)',
  [BRIGHTNESS_IMAGES]: 'brightness(100%)'
};

// Duck color
const DUSK_COLOR = {
  [BLACK_COLOR]: '#7C8A7F', //-----
  [BLACK_ALPHA_6_COLOR]: 'rgba(124, 138, 127, .6)', //-----
  [BLACK_ALPHA_8_COLOR]: 'rgba(124, 138, 127, .8)', //-----
  [LIGHT_30_BLACK_COLOR]: '#95A198', // ----10%
  [LIGHT_50_BLACK_COLOR]: '#A3ADA5', // ----15%
  [LIGHT_50_BLACK_ALPHA_8_COLOR]: 'rgba(163, 173, 165, .8)', //----
  [LIGHT_60_BLACK_COLOR]: '#ADB7AF', // ----19%
  [BLUE_COLOR]: '#375262', //------------
  [LIGHT_50_BLUE_COLOR]: '#527B92', // ------15%
  [DARK_5_BLUE_COLOR]: '#2D4451', // -----5%
  [GREEN_COLOR]: '#509A28', //-----
  [ORANGE_COLOR]: '#915728',
  [RED_COLOR]: '#9E3522', //-----
  [WHITE_COLOR]: 'black', //-----
  [OFFLINE_COLOR]: 'rgba(83, 92, 84, 1)', //-----
  [S52_COLOR_APLRT]: 'rgb(145,87,40)',
  [S52_COLOR_PSTRK]: 'rgb(157,176,161)',
  [S52_COLOR_SHIPS]: 'rgb(73,81,74)',
  [S52_COLOR_SYTRK]: 'rgb(95,106,96)',
  [S52_COLOR_CHRED]: 'rgb(164,65,75)',
  [S52_COLOR_RESBL]: 'rgb(57,99,163)',
  [BRIGHTNESS_IMAGES]: 'brightness(60%)'
};

// Night color
const NIGHT_COLOR = {
  [BLACK_COLOR]: '#393F39', // ----
  [BLACK_ALPHA_6_COLOR]: 'rgba(57, 63, 57, .6)', //-----
  [BLACK_ALPHA_8_COLOR]: 'rgba(57, 63, 57, .8)', //-----
  [LIGHT_30_BLACK_COLOR]: '#464D46', // ----- 5%
  [LIGHT_50_BLACK_COLOR]: '#525B52', // -----10%
  [LIGHT_50_BLACK_ALPHA_8_COLOR]: 'rgba(82, 91, 82, .8)',
  [LIGHT_60_BLACK_COLOR]: '#576057', // ----12%
  [BLUE_COLOR]: '#1E2B31', //--------
  [LIGHT_50_BLUE_COLOR]: '#30454F', // ------10%
  [DARK_5_BLUE_COLOR]: '#131B1F', // ---------5%
  [GREEN_COLOR]: '#27460D', //-----
  [ORANGE_COLOR]: '#422a0e',
  [RED_COLOR]: '#441A08', //-----
  [WHITE_COLOR]: 'black', //-----
  [OFFLINE_COLOR]: 'rgba(45, 49, 43, 1)', //-----
  [S52_COLOR_APLRT]: 'rgb(66,42,14)',
  [S52_COLOR_PSTRK]: 'rgb(73,81,74)',
  [S52_COLOR_SHIPS]: 'rgb(157,176,161)',
  [S52_COLOR_SYTRK]: 'rgb(45,50,44)',
  [S52_COLOR_CHRED]: 'rgb(74,33,35)',
  [S52_COLOR_RESBL]: 'rgb(29,47,72)',
  [BRIGHTNESS_IMAGES]: 'brightness(30%)'
};

// Change colors according to the constants
function changeColor(colors, online) {
  let colorValue;
  for (const color in colors) {
    if (color === BLUE_COLOR) {
      colorValue = online ? colors[color] : colors[OFFLINE_COLOR];
    } else {
      colorValue = colors[color];
    }
    setCSSProperty(`--${color}`, colorValue);
  }
}

function setCSSProperty(cssVariableName, value, targetElement = document.documentElement) {
  targetElement.style.setProperty(cssVariableName, value);
}

/**
 * Get the color corresponding to label.
 * @param {string} guiColor The gui color name (BLUE_COLOR, RED_COLOR, etc.)
 * @param {string} lightCondition light condition (DAY, DUSK, NIGHT).
 * @return {string} The css color
 */
export function getGUIColor(guiColor, lightCondition) {
  let color;
  switch (lightCondition) {
    case LIGHT_CONDITION.DAY:
      color = DAY_COLOR[guiColor];
      break;
    case LIGHT_CONDITION.DUSK:
      color = DUSK_COLOR[guiColor];
      break;
    case LIGHT_CONDITION.NIGHT:
      color = NIGHT_COLOR[guiColor];
      break;
    default:
      break;
  }
  return color;
}

/**
 * Change the GUI interface color according the parameter.
 * @param {LIGHT_CONDITION} lightCondition day, dusk or nigth
 * @param {boolean} isOnline True if online
 */
export function setGUIColor(lightCondition, isOnline = true) {
  switch (lightCondition) {
    case LIGHT_CONDITION.DAY:
      changeColor(DAY_COLOR, isOnline);
      break;
    case LIGHT_CONDITION.DUSK:
      changeColor(DUSK_COLOR, isOnline);
      break;
    case LIGHT_CONDITION.NIGHT:
      changeColor(NIGHT_COLOR, isOnline);
      break;
    default:
      break;
  }
}
